import { render, staticRenderFns } from "./editor-controls.vue?vue&type=template&id=f5142140&"
import script from "./editor-controls.vue?vue&type=script&lang=js&"
export * from "./editor-controls.vue?vue&type=script&lang=js&"
import style0 from "./editor-controls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports